/**
 * @function decode
 * @since 1.0.0
 */
export function decode(string) {
    try {
        return JSON.parse(string);
    }
    catch (e) {
        return {};
    }
}
/**
 * @function isJSON
 * @since 1.0.0
 */
export function isJSON(string) {
    try {
        JSON.parse(string);
        return true;
    }
    catch (e) {
        return false;
    }
}
